import Vue from 'vue'
import axios from 'axios';

//sistema

Vue.prototype.$listarUsuarios = async () => {
  try {
    let res = await axios.get('users/sistema', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$listarTiposUsuario = async () => {
  try {
    let res = await axios.get('tipos/usuarios', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

//admin&super
Vue.prototype.$listarAdminEsuper = async () => {
  try {
    let res = await axios.get('users/sistema/admin&super', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

//cidadao
Vue.prototype.$listarUsuariosCidadaos = async () => {
  try {
    let res = await axios.get('users/sistema/cidadao', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$me = async () => {
  try {
    let res = await axios.post('auth/me', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$buscarCidadao = async (cidadao) => {
  try {
    let res = await axios.get('users/buscar/cidadao/'+ cidadao, {});
    return res.data;
  } catch (e) {
    throw e;
  }
}


//users/sistema/cadastro
Vue.prototype.$usuarioCadastro = async (usuario) =>{
  try { 
    let res = await axios.post('users/sistema/cadastro',{
        nome: usuario.nome,
        senha: usuario.senha,
        email: usuario.email,
        gestor_cpf: usuario.cpf, 
        telefone: usuario.telefone,
        tipo: usuario.tipo,
        departamento: usuario.departamento,
        status: usuario.status, 
    });
   return res.data;
  } catch (e) {
    if(e.message == "Request failed with status code 401"){
      let msg ="Email já está em uso!";
      return msg
    }
  } 
}

//users/sistema/editar
Vue.prototype.$usuarioEditar = async (usuario,id) =>{
  try { 
    let res = await axios.post('usuario/edit/'+id,
    {
        nome: usuario.nome,
        senha: usuario.senha,
        email: usuario.email,
        gestor_cpf: usuario.cpf, 
        telefone: usuario.telefone,
        tipo: usuario.tipo,
        departamento: usuario.departamento,
        status: usuario.status,  
    }
    );
  return res.data;
  } catch (e) {
    if(e.message == "Request failed with status code 401"){
      let msg ="Email já está em uso!";
      return msg
    }
  } 
}

Vue.prototype.$usuarioDelete = async (id,usuario) => {
  try {
    let res = await axios.delete('users/sistema/delete/'+id+'/usuario/'+usuario, {
    });
    return res.data;
  } catch (e) {
    //console.log(e);
  }
}

Vue.prototype.$usuarioEditarStatus = async (id,status) =>{
  try { 
    //console.log(cidadao);
    let res = await axios.put('users/editar/'+id+'/status',{
        status: status, 
    });
    return res.data;
  } catch (e) {
    
  } 
}